import { ElementRef } from '@angular/core';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoginService } from 'src/app/login.service';
import { environment as env } from '../../../environments/environment';
@Component({
  selector: 'app-campaign-details',
  templateUrl: './campaign-details.component.html',
  styleUrls: ['./campaign-details.component.scss'],
})
export class CampaignDetailsComponent implements OnInit {
  campaignId: any;
  jsonData: any = [];
  token: any;
  campaign: any;
  campaignPriorities: any;
  isUploading: boolean = true;
  count: number = 0;
  headers: any = [];
  fileName: any;
  @ViewChild('file', { static: false })
  myInputVariable!: ElementRef;

  // this InputVar is a reference to our input.
  inputVar: any;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private apiService: LoginService,
    private toaster: ToastrService
  ) {
    this.campaignId = this.route.snapshot.params['data'];
  }
  url = env.url;
  limit = 50000;
  pages: any;
  ngOnInit(): void {
    this.token = localStorage.getItem('token');
    this.getCampaign();
  }
  getCampaign() {
    this.apiService.getCampaign(this.campaignId).subscribe(
      (res: any) => {
        if (res['status'] == 'success') {
          this.campaign = res['result'].capData;
          this.count = res['result'].count;
          this.pages = Math.ceil(this.count / this.limit);
        }
      },
      (err) => {
        this.toaster.error(err.message);
      }
    );
    this.apiService.getCampaignPriority(this.campaignId).subscribe(
      (res: any) => {
        if (res['status'] == 'success') {
          this.campaignPriorities = res['result'];
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }
  goToBack() {
    this.router.navigate(['/campaign']);
  }
  handleFileInput(event: any) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.fileName = event.target.files[0].name;
      const formData: FormData = new FormData();
      formData.append('file', file);
      formData.append('campaign_id', this.campaignId);
      this.isUploading = false;
      this.apiService.getSignedUrl(file).subscribe(
        (res:any) =>{
          this.apiService.uploadFileToS3(res.result?.putUrl,file).subscribe((uploadRes:any)=>{
            this.apiService.bulkInsertCustomerData({url:res.result?.getUrl,campaignId:this.campaignId}).subscribe((bulkUploadRes:any)=>{
                if(bulkUploadRes.status === "success"){
                  this.isUploading = true;
                  this.toaster.success("Imported data Successfully");
                  this.getCampaign();
                  if(bulkUploadRes.result.failedRecordFileUrl){
                    this.apiService.downloadS3File(bulkUploadRes.result.failedRecordFileUrl)
                  }
                  this.myInputVariable.nativeElement.value = '';

                }else{
                  this.isUploading = true;
                  this.myInputVariable.nativeElement.value = '';
                  this.toaster.error(bulkUploadRes?.error?.message);
      
                }
            },(err:any) => {
              console.log("error",err)
              this.isUploading = true;
              this.myInputVariable.nativeElement.value = '';

            })
          },
          (err:any) => {
            console.log("error",err)
            this.isUploading = true;
            this.myInputVariable.nativeElement.value = '';

          })
        },
        (err:any) => {
          this.isUploading = true;
          this.myInputVariable.nativeElement.value = '';

        }
      )
    }
  }
  editCampaign() {
    this.router.navigate(['/edit-campaign-detail', { data: this.campaignId }]);
  }

  isShown: boolean = false; // hidden by default
  toggleShow() {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      this.isShown = !this.isShown;
    } else {
      console.log('not mobile');
    }
  }
  exportReport() {
    this.apiService.exportReport(this.campaignId, this.token).subscribe(
      (res: any) => {
        if (res['status'] == 'success') {
          if (res.result.length > 0) {
            this.headers = Object.keys(res.result[0]);
            this.jsonData = res.result;
            this.fileName = `export_campaign_${this.campaignId}_data`;
            this.download();
          } else {
            this.toaster.success(`THERE IS NO DATA TO EXPORT FOR CAMPAIGN`);
          }
        }
      },
      (err) => {
        this.toaster.error(`Some error while export report`);
      }
    );
  }

  download(i = 0) {
    this.apiService.downloadFile(this.jsonData, this.fileName, this.headers);
  }

  exportCustomer() {
    let pages = Math.ceil(this.count / this.limit);
    if (pages > 0) {
      for (let ind = 0; ind < pages; ind++) {
        this.isUploading = false;
        this.apiService
          .exportCustomer(this.token, this.campaignId, this.limit, 1)
          .subscribe(
            (res: any) => {
              if (res[`status`] == 'success') {
                if (res.result) {
                  this.headers = Object.keys(res.result[0]);
                  if (
                    Object.keys(res.result[0]?.original_customfield).length > 0
                  ) {
                    const customHeaders = Object.keys(
                      res?.result[0]?.original_customfield
                    );
                    const updatedCustomHeaders: {
                      columnName: string;
                      updatedColumnName: string;
                    }[] = [];
                    customHeaders.forEach((o) => {
                      updatedCustomHeaders.push({
                        columnName: o,
                        updatedColumnName: `original_customfield_${o}`,
                      });
                      updatedCustomHeaders.push({
                        columnName: o,
                        updatedColumnName: `edited_customfield_${o}`,
                      });
                    });
                    const originalCustomfieldIndex = this.headers.findIndex(
                      (o: string) => o === `original_customfield`
                    );
                    const customFields = updatedCustomHeaders.map(
                      ({ updatedColumnName }) => updatedColumnName
                    );
                    this.headers.splice(
                      originalCustomfieldIndex,
                      2,
                      ...customFields
                    );
                    for (let index = 0; index < res.result.length; index++) {
                      const row = res.result[index];

                      customFields.forEach((o, i) => {
                        const originalCustomfieldValue =
                          row.original_customfield;
                        const editedCustomfieldValue = row.edited_customfield;

                        if (i % 2 === 0) {
                          row[o] = originalCustomfieldValue
                            ? originalCustomfieldValue[
                                updatedCustomHeaders[i].columnName
                              ]
                            : '';
                        } else {
                          row[o] = editedCustomfieldValue
                            ? editedCustomfieldValue[
                                updatedCustomHeaders[i].columnName
                              ]
                            : '';
                        }
                      });
                    }
                  }
                  this.jsonData = res.result;
                  this.fileName = `export_campaign_${
                    this.campaign.campaign_name
                  }_data_${1}`;
                  this.download();
                  if (ind == pages - 1) {
                    this.isUploading = true;
                  }
                }
              }
            },
            (err) => {
              this.toaster.error(`ERROR OCCURED FOR PAGE ${ind + 1}`);
            }
          );
      }
    } else {
      this.toaster.success(`THERE IS NO DATA TO EXPORT FOR CUSTOMER`);
    }
  }
}


